import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@shape-ds/components';
import { useOverflowDetector } from 'react-detectable-overflow';
import './style.scss';
import { IconButton } from '@mui/material';

interface ExpandTextProps {
  text: string | React.ReactNode;
  children?: React.ReactNode;
  rows?: number;
}

const ExpandText: React.FC<ExpandTextProps> = ({ children, text, rows = 1 }) => {
  const [expanded, setExpanded] = useState(false);
  const { ref, overflow } = useOverflowDetector({});

  useEffect(() => {
    setExpanded(false);
  }, [text]);

  const classModifier = expanded ? 'open' : 'closed';
  const isExpandable = overflow || expanded;

  return (
    <Box className={`expand-text-wrapper ${classModifier}`}>
      <div className="expand-text-content">
        <span ref={ref} className={`expand-text-box ${classModifier}`} data-rows={rows}>
          {text}
        </span>
        <span className="expand-text-more">
          {children}
          <IconButton
            aria-label={expanded ? 'Collapse text' : 'Expand text'}
            aria-expanded={expanded}
            className={`expand-button${isExpandable ? '' : ' hidden'}`}
            aria-controls="expand-text-content"
            onClick={() => setExpanded((prev) => !prev)}
            tabIndex={isExpandable ? 0 : -1}
            disabled={!isExpandable}
            style={isExpandable ? {} : { visibility: 'hidden' }}
          >
            <ExpandMoreIcon data-testid="expand-more-icon" />
          </IconButton>
        </span>
      </div>
    </Box>
  );
};
export default ExpandText;
